import React, { useState, useRef, useEffect } from 'react';

const Tooltip = ({ children, content }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const triggerRef = useRef(null);
    const tooltipRef = useRef(null);

    useEffect(() => {
        if (isVisible && triggerRef.current && tooltipRef.current) {
            const triggerRect = triggerRef.current.getBoundingClientRect();

            setPosition({
                top: -triggerRect.height / 2,
            });
        }
    }, [isVisible]);

    return (
        <div className="tooltip-container relative">
            <div
                ref={triggerRef}
                className="cursor-pointer"
                onMouseEnter={() => setIsVisible(true)}
                onMouseLeave={() => setIsVisible(false)}
            >
                {children}
            </div>
            {isVisible && (
                <div
                    ref={tooltipRef}
                    className="tooltip absolute w-[328px] p-3 rounded-lg bg-white shadow-lg border border-solid border-gray-200 z-50 -translate-x-[90%] md:-translate-x-1/2 -translate-y-full"
                    style={{ top: `${position.top}px` }}
                >
                    <div className="tooltip-arrow"></div>
                    <p className="text-xs leading-[18px] font-semibold text-black mb-1">{content.tooltipContentTitle}</p>
                    <p className="text-xs font-normal leading-[18px] text-[#00000070]">{content.tooltipContentBody}</p>
                </div>
            )}
        </div>
    );
};

export default Tooltip;